import React from "react";
import {
  Card,
  PrimaryButton,
  formatCurrency,
} from "../../UI/DesignStandards";
import { formatSquadInfo } from "../../UI/DesignStandards/Utilities/DateTime";
import { addCurrency } from "../../../utils/currencyUtils";

const ThisEntrySummary = ({
  event,
  squad,
  slots = [],
  sidepotTotal = 0,
  bracketTotal = 0,
  waitlisted = false,
  cartCount = 0,
  onViewCart,
}) => {
  const named = slots.filter((slot) => String(slot.name || "").trim());
  const bowlerCount = Math.max(
    1,
    Number(event?.bowlerQuantity) || named.length || 1
  );
  const entry = Number(event?.entryFee || 0) * bowlerCount;
  const total = addCurrency(addCurrency(entry, sidepotTotal), bracketTotal);

  return (
    <Card
      className="overflow-hidden lg:max-h-[calc(100vh-1.5rem)] lg:overflow-y-auto"
      padding=""
    >
      <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
        <h2 className="font-display font-bold text-lg text-brand-cream tracking-tight">
          This entry
        </h2>
        {cartCount > 0 ? (
          <p className="text-sm text-brand-mist mt-1">
            {cartCount} {cartCount === 1 ? "entry" : "entries"} already in the
            cart.
          </p>
        ) : (
          <p className="text-sm text-brand-mist mt-1">
            Pick an event, squad, and bowlers.
          </p>
        )}
      </div>
      <div className="p-6 space-y-3 text-sm">
        <div>
          <div className="text-brand-muted">Event</div>
          <div className="font-semibold text-brand-charcoal">
            {event?.eventName || "Pick an event"}
          </div>
        </div>
        <div>
          <div className="text-brand-muted">Squad</div>
          <div className="font-semibold text-brand-charcoal">
            {squad
              ? formatSquadInfo(squad.squadDate, squad.squadTime)
              : "Pick a squad"}
          </div>
          {squad?.bowlingCenters?.centerName ? (
            <div className="text-brand-muted">
              {squad.bowlingCenters.centerName}
            </div>
          ) : null}
        </div>
        <div>
          <div className="text-brand-muted">Bowlers</div>
          <div className="text-brand-charcoal">
            {named.length
              ? named.map((slot) => slot.name).join(", ")
              : "Not entered yet"}
          </div>
        </div>
        {waitlisted ? (
          <div className="font-semibold text-brand-charcoal">Join waitlist</div>
        ) : null}
        <div className="pt-2 border-t border-brand-charcoal/10">
          <div className="flex justify-between">
            <span>Entry</span>
            <span>{formatCurrency(entry)}</span>
          </div>
          {sidepotTotal > 0 ? (
            <div className="flex justify-between">
              <span>Sidepots</span>
              <span>{formatCurrency(sidepotTotal)}</span>
            </div>
          ) : null}
          {bracketTotal > 0 ? (
            <div className="flex justify-between">
              <span>Brackets</span>
              <span>{formatCurrency(bracketTotal)}</span>
            </div>
          ) : null}
          <div className="flex justify-between font-semibold mt-2">
            <span>This line</span>
            <span>{formatCurrency(total)}</span>
          </div>
        </div>
        {cartCount > 0 ? (
          <div className="pt-3">
            <PrimaryButton className="w-full py-3" onClick={onViewCart}>
              View cart ({cartCount})
            </PrimaryButton>
          </div>
        ) : null}
      </div>
    </Card>
  );
};

export default ThisEntrySummary;
